import React from 'react'

function FemaleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H48V40H0z"
            data-name="Rectangle 7152"
            transform="translate(-.444)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="female icon" transform="translate(.444)">
        <g fill="#263238" data-name="Group 51964" transform="translate(8.556 2.309)">
          <path
            d="M30.352-165.62a10.491 10.491 0 01-4.814-1.488.923.923 0 01-.374-1.251.923.923 0 011.251-.374c2.525 1.363 4.372 1.631 5.491.8s1.7-2.873 1.7-5.9a45.135 45.135 0 00-1.034-8.549 13.023 13.023 0 00-2.973-6.333 5.412 5.412 0 00-4.679-1.842.923.923 0 01-.619-.139 9.957 9.957 0 00-4.35-1.613 8.673 8.673 0 00-3.946.519 13.26 13.26 0 00-6.176 5.139c-1.768 2.626-2.508 6.828-2.653 8.683l-.059.733c-.254 3.089-.571 6.933 1.334 8.564 1.144.979 3.116 1.139 5.861.476a.923.923 0 011.114.68.923.923 0 01-.68 1.114 12.734 12.734 0 01-4.449.391 5.637 5.637 0 01-3.046-1.259c-2.622-2.245-2.263-6.611-1.974-10.119l.059-.724c.169-2.172.984-6.632 2.962-9.57a15.11 15.11 0 017.067-5.839 10.777 10.777 0 019.658 1.1 7.164 7.164 0 015.92 2.441 14.838 14.838 0 013.439 7.226 46.961 46.961 0 011.073 8.922 15.858 15.858 0 01-.487 4.233 5.718 5.718 0 01-1.958 3.154 4.327 4.327 0 01-2.658.825z"
            data-name="Path 64478"
            transform="translate(-5.078 194.206)"
          ></path>
          <path
            d="M136.781-7.746a.923.923 0 01-.881-.654.923.923 0 01.61-1.154 5.235 5.235 0 003.589-3.482 7.432 7.432 0 00.376-2.647.922.922 0 01.842-1 .924.924 0 011 .843 9.189 9.189 0 01-.444 3.321 7.084 7.084 0 01-4.816 4.726.923.923 0 01-.276.047z"
            data-name="Path 64487"
            transform="translate(-130.371 43.744)"
          ></path>
          <path
            d="M141.406-7.746a.922.922 0 01-.273-.041 7.083 7.083 0 01-4.816-4.726 9.189 9.189 0 01-.444-3.321.923.923 0 011-.842.923.923 0 01.842 1 7.437 7.437 0 00.376 2.647 5.234 5.234 0 003.588 3.482.923.923 0 01.609 1.154.924.924 0 01-.882.647z"
            data-name="Path 64488"
            transform="translate(-118.267 43.744)"
          ></path>
          <path
            d="M50.038-186.97a9.824 9.824 0 01-7.029-3.377 14.112 14.112 0 01-3.9-10.083.923.923 0 01.7-.843 3.306 3.306 0 001.844-1.235 1.671 1.671 0 00.1-1.346.923.923 0 01.183-.847.923.923 0 01.8-.322 19.717 19.717 0 004.2-.093c1.917-.26 4.423-.962 5.474-2.83a.923.923 0 011.257-.352.923.923 0 01.352 1.257c-2.119 3.765-7.866 4.007-10.338 3.925a3.293 3.293 0 01-.444 1.541 4.7 4.7 0 01-2.309 1.864 11.3 11.3 0 00.823 3.99 12.964 12.964 0 002.591 4.106 8.014 8.014 0 005.686 2.8c2.289 0 4.513-1.368 6.263-3.851a16.489 16.489 0 002.762-7.361 4.531 4.531 0 01-1.556.026 5.351 5.351 0 01-2.314-1 8.038 8.038 0 01-1.936-2.046.923.923 0 01.3-1.271.923.923 0 011.269.3 6.215 6.215 0 001.49 1.552 2.972 2.972 0 003.351.281.923.923 0 01.922.036.923.923 0 01.43.817 18.53 18.53 0 01-3.199 9.732c-2.11 2.984-4.866 4.63-7.772 4.63z"
            data-name="Path 64479"
            transform="translate(-35.031 216.701)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default FemaleIcon
